import React from 'react';

interface GridSkeletonProps {
  count?: number;
}

const GridSkeleton: React.FC<GridSkeletonProps> = ({ count = 12 }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-4">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="animate-pulse border border-gray-200 rounded-md bg-white p-4">
          <div className="h-5 bg-gray-100 rounded mb-3"></div>
          <div className="flex items-center justify-between mb-3">
            <div className="h-5 w-20 bg-gray-100 rounded-full"></div>
            <div className="h-4 w-4 bg-gray-100 rounded"></div>
          </div>
          <div className="space-y-2 mb-3">
            <div className="h-4 bg-gray-100 rounded w-3/4"></div>
            <div className="h-3 bg-gray-100 rounded w-1/2"></div>
          </div>
          <div className="h-3 bg-gray-100 rounded w-2/3"></div>
        </div>
      ))}
    </div>
  );
};

export default GridSkeleton;
